export enum SortType{
    up,
    down,
    none
}